export default __webpack_public_path__ + "static/team-member-1-496ab5d63a7b3ba6604a4b0b4b004488.png";